import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getRegulationsFinanceProductivity: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_FINANCE_PRODUCTIVITY].GET_REGULATIONS_FINANCE_PRODUCTIVITY,
	},
}